module.exports = __webpack_public_path__ + "img/pageheader_logo_text_alpha_white_low_res.8befad67.png";